import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// One address per site: the login is stored per origin, so www.example.com and
// example.com would each need their own login. Send www to the bare domain, keeping the path.
if (window.location.hostname.startsWith('www.')) {
  const { protocol, hostname, port, pathname, search, hash } = window.location;
  window.location.replace(`${protocol}//${hostname.slice(4)}${port ? `:${port}` : ''}${pathname}${search}${hash}`);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
